import {
  Divider,
  StyledFrownIcon,
  StyledModalTitle,
  StyledSecurityInfo,
} from '@components/ErrorModal/ErrorModalStyles'
import {
  ErrorModalContentProps,
  ErrorModalProps,
} from '@components/ErrorModal/ErrorModalTypes'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { Modal } from '../Modal'
import { Typography } from '../Typography'

const ErrorModalContent: React.FC<ErrorModalContentProps> = ({
  errorMessage,
  onRequestClose,
  className,
}) => {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <StyledModalTitle>
        <StyledFrownIcon src="" />
        {t('errorModal.title')}
      </StyledModalTitle>

      <Modal.Content>
        {errorMessage && <Typography>{errorMessage}</Typography>}

        <Divider />

        <StyledSecurityInfo>{t('errorModal.securityInfo')}</StyledSecurityInfo>
      </Modal.Content>
    </div>
  )
}

export const ErrorModal: React.FC<ErrorModalProps> = ({
  errorMessage,
  onRequestClose,
  error,
  showBackToTheFormBtn = false,
  ...props
}) => {
  return (
    <Modal
      {...props}
      id="error-modal"
      showCloseButton
      onRequestClose={onRequestClose}
    >
      <ErrorModalContent
        errorMessage={errorMessage}
        onRequestClose={onRequestClose}
      />
    </Modal>
  )
}
